import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { CounterpartyContactPerson } from './types';

export const counterpartyContactPersonsApi = createApi({
  reducerPath: 'counterpartyContactPersonsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/counterparty-contact-persons`,
  }),
  tagTypes: ['CounterpartyContactPerson', 'Counterpart'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    createCounterpartyContactPerson: builder.mutation<
      CounterpartyContactPerson,
      CounterpartyContactPerson
    >({
      query: data => ({
        url: '/',
        method: 'POST',
        data: data,
      }),
      invalidatesTags: ['CounterpartyContactPerson', 'Counterpart'],
    }),
    updateCounterpartyContactPersonById: builder.mutation<
      string,
      CounterpartyContactPerson
    >({
      query: data => ({
        url: `/${data.id}`,
        method: 'PUT',
        data: data,
      }),
      invalidatesTags: ['CounterpartyContactPerson', 'Counterpart'],
    }),
    deleteCounterpartyContactPersonById: builder.mutation<
      CounterpartyContactPerson,
      string
    >({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CounterpartyContactPerson', 'Counterpart'],
    }),
    counterpartyContactPersonSendActivationRequest: builder.mutation<
      CounterpartyContactPerson,
      string
    >({
      query: id => ({
        url: `/${id}/send-activation-request`,
        method: 'POST',
      }),
      invalidatesTags: ['CounterpartyContactPerson', 'Counterpart'],
    }),
  }),
});

export const {
  useCreateCounterpartyContactPersonMutation,
  useDeleteCounterpartyContactPersonByIdMutation,
  useUpdateCounterpartyContactPersonByIdMutation,
  useCounterpartyContactPersonSendActivationRequestMutation,
} = counterpartyContactPersonsApi;
